<template>
  <div
    v-if="chartComponent"
    class="fill-height"
  >
    <component
      :is="chartComponent"
      :stats="stats"
      :current-date="currentDate"
      :player-stats="playerStats"
      :date="currentDate"
      :loading="loading"
      :variables="variables"
      :selected-variable="chart.variable"
      :removable="removable"
      @remove="$emit('remove')"
    />
  </div>
</template>

<script>
import FreshnessChart from '@/components/charts/implementation/FreshnessChart.vue'
import TrainingLoadChart from '@/components/charts/implementation/TrainingLoadChart.vue'
import LoadOverviewChart from '@/components/charts/implementation/LoadOverviewChart.vue'
import WeeklyLoadChart from '@/components/charts/implementation/WeeklyLoadChart.vue'
import PlayerSleepStatusChart from '@/components/charts/implementation/PlayerSleepStatusChart.vue'
import PlayerMoodStressChart from '@/components/charts/implementation/PlayerMoodStressChart.vue'
import PlayerGeneralMuscleSorenessChart from '@/components/charts/implementation/PlayerGeneralMuscleSorenessChart.vue'
import dayjs from 'dayjs'

export default {
  name: 'LoadChartIndividual',
  components: {
    FreshnessChart,
    TrainingLoadChart,
    LoadOverviewChart,
    WeeklyLoadChart,
    PlayerSleepStatusChart,
    PlayerMoodStressChart,
    PlayerGeneralMuscleSorenessChart
  },
  props: {
    stats: {
      type: Array,
      required: true
    },
    removable: {
      type: Boolean,
      default: false
    },
    chart: {
      type: Object,
      required: true
    },
    variables: {
      type: Array,
      default: () => []
    },
    currentDate: {
      type: Object,
      default: () => dayjs()
    },
    loading: {
      type: Boolean,
      default: false
    },
    player: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    chartComponent() {
      const componentMap = {
        LOAD_OVERVIEW: 'LoadOverviewChart',
        WEEK_CHANGE: 'WeeklyLoadChart',
        FRESHNESS: 'FreshnessChart',
        TRAINING_LOAD: 'TrainingLoadChart',
        SLQ_SLD_PLAYER: 'PlayerSleepStatusChart',
        MOO_STL_PLAYER: 'PlayerMoodStressChart',
        GMS_PLAYER: 'PlayerGeneralMuscleSorenessChart'
      }

      return componentMap[this.chart.key] || null
    },
    playerStats() {
      return this.stats.map(item => {
        return {
          ...item,
          stats: item.stats ?? item.player_stats
        }
      })
    }
  }
}
</script>
